import {css} from '@emotion/react'
import useSWR from 'swr/immutable'
import {Modal} from 'antd'
import http from '@/biz/http.mjs'

const MESSAGE = '此功能未授权，请购买更高级别的许可证'

export const useCheckLicense = () => {
    const isLicensed = useIsLicensed()

    return code => {
        if (! isLicensed(code)) {
            Modal.error({content: MESSAGE})
            throw new Error(MESSAGE)
        }
    }
}

export const useFilterByLicense = () => {
    const isLicensed = useIsLicensed()
    return (code, a) => isLicensed(code) ? a : null
}

export const useIsLicensed = () => {
    const {data: {moduleList = []} = {}} = useLicense()
    const codes = new Set(moduleList)
    return code => codes.has(code)
}

export const useLicense = () => useSWR(
    '/license/authentication',
    url => http.get(url)
)

const cssUnlicensed = css({
})

export const Unlicensed = props => {
    return (
        <div
            css={cssUnlicensed}
            {...props}
        >
            {MESSAGE}
        </div>
    )
}
